module.exports = __webpack_public_path__ + "static/media/ktm-05.b053cb9d.jpg";